import { AcceptAdvisorInvitationRequest } from '../../models/Advisor';
import { publicAdvisorInvitationService } from '../../services/PublicAdvisorInvitationService';
import { createComprehensiveErrorHandler } from '../../utils/advisorErrorHandling';

type FormErrors = {
  firstName?: string;
  lastName?: string;
  mobile?: string;
};

export function buildAcceptanceData(
  isExistingContact: boolean,
  formData: AcceptAdvisorInvitationRequest,
): AcceptAdvisorInvitationRequest {
  if (isExistingContact) {
    return { firstName: '', lastName: '', mobile: '' };
  }
  return formData;
}

export function validateInvitationForm(
  isExistingContact: boolean,
  formData: AcceptAdvisorInvitationRequest,
): FormErrors {
  if (isExistingContact) {
    return {};
  }

  const errors: FormErrors = {};
  if (!formData.firstName.trim()) {
    errors.firstName = 'First name is required';
  }
  if (!formData.lastName.trim()) {
    errors.lastName = 'Last name is required';
  }
  if (!formData.mobile.trim()) {
    errors.mobile = 'Mobile number is required';
  }
  return errors;
}

export async function submitAdvisorInvitationAcceptance(input: {
  invitationId: string;
  isExistingContact: boolean;
  formData: AcceptAdvisorInvitationRequest;
}): Promise<{ success: true } | { success: false; message: string }> {
  try {
    const result = await publicAdvisorInvitationService.acceptAdvisorInvitation(
      input.invitationId,
      buildAcceptanceData(input.isExistingContact, input.formData),
    );

    if (result.status === 'ACCEPTED') {
      return { success: true };
    }
    return { success: false, message: result.error || 'Failed to accept invitation' };
  } catch (acceptError: unknown) {
    const errorHandler = createComprehensiveErrorHandler({
      operation: 'accept',
      invitationId: input.invitationId,
    });
    return { success: false, message: errorHandler(acceptError).message };
  }
}
